import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { AuthGuard } from './AuthGuard';
import { AuthStore } from '../hooks/useAuth';

const TOKEN_KEY = 'field_assist_token';

interface TokenGateProps {
  children: (store: AuthStore) => React.ReactNode;
}

/**
 * Reads the auth token from the URL (?token=...) and persists it. If no
 * token is available anywhere, redirects to /login.
 */
export const TokenGate: React.FC<TokenGateProps> = ({ children }) => {
  const location = useLocation();
  const [token, setToken] = useState<string | null>(null);
  const [bootstrapped, setBootstrapped] = useState(false);

  useEffect(() => {
    const url = new URL(window.location.href);
    const urlToken = url.searchParams.get('token');

    if (urlToken) {
      sessionStorage.setItem(TOKEN_KEY, urlToken);
      url.searchParams.delete('token');
      window.history.replaceState({}, '', url.toString());
    }

    const stored =
      urlToken ||
      sessionStorage.getItem(TOKEN_KEY) ||
      sessionStorage.getItem('utoken');

    setToken(stored);
    setBootstrapped(true);
  }, []);

  if (!bootstrapped) return null;

  if (!token) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return <AuthGuard token={token}>{children}</AuthGuard>;
};
